import { render, staticRenderFns } from "./eventsHome.vue?vue&type=template&id=75b77c26&scoped=true&"
import script from "./eventsHome.vue?vue&type=script&lang=js&"
export * from "./eventsHome.vue?vue&type=script&lang=js&"
import style0 from "./eventsHome.vue?vue&type=style&index=0&id=75b77c26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b77c26",
  null
  
)

export default component.exports